import React from 'react';
import ContentTemplate from '../ContentTemplate/ContentTemplate';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getUserProfileWidget } from '../../selectors/index';
import IFrameEmbed from '../WSAControls/Embed/IFrameEmbed'
import Cookies from 'js-cookie';
import { injectIntl } from 'react-intl';
import s from './DataAnalysis.module.scss';

let analysisUrl = process.env.REACT_APP_DATA_ANALYSIS;
const envName = process.env.REACT_APP_ENV_NAME_SHORT;

const DataAnalysis = ({ intl }) => {
    const { unitSerialNumber } = useParams();
    const userProfileWidgets = useSelector(state => getUserProfileWidget(state));
    const token = Cookies.get(`access-${envName}`);
    const orgId = Cookies.get(`selectedorganisationid-${envName}`) || 0;
    const profileid = Cookies.get(`selectedprofileid-${envName}`) || 0
    const title = intl.formatMessage({
        id: 'dataAnalysis.dataAnalysis',
        defaultMessage: 'Data Analysis'
    });

    let src = `${analysisUrl}?token=${token}&accessid=${profileid}&unitserialnumber=${unitSerialNumber}&orgid=${orgId}`
    return (
        <div className={s.dataAnalysis}>
            <ContentTemplate
                selectedPage="dataAccess"
                userProfileWidgets={userProfileWidgets}
                widgetCode={'UNITDATAACCESS'}
            >
                <div className={s.dataAnalysisContent}>
                    <IFrameEmbed src={src} title={title} width="100%" height="100%" />
                </div>
            </ContentTemplate>
        </div>
    );
};

export default injectIntl(DataAnalysis)

